import React from 'react'
import { H2Generator } from '../../functions/H2Generator'
import { api } from '../../../../src/services/api'

import { Forms } from './CatgCreation/index'
import { CatgTable } from './CadTableList/index'
import { ConfirmationModal } from '../UserAdmin/ConfirmationModal'

import styles from './category.module.scss'
import { motion, useAnimation } from 'framer-motion'

interface CatgProps {
    props?: any
}

interface Categoria {
    ID: number,
    CM_NOME: string,
    CM_PARENTE_ID: number
}

export function CatgAdmin(props: CatgProps) {

    const [data, setData] = React.useState<Categoria[]>([])

    React.useEffect(() => {
        const fetchData = async () => {
            const result = await api.get('/categorias')
                .then((resp => resp.data))

            setData(result)
        }

        fetchData()
    }, [])

    function getUser() {
        const fetchData = async () => {
            const result = await api.get('/categorias')
                .then((resp => resp.data))

            setData(result)
        }

        fetchData()
    }

    const [catgData, setCatgData] = React.useState({
        ID: '',
        CM_NOME: '',
        CM_PARENTE_ID: -1
    })

    const [catgDeleteData, setCatgDeleteData] = React.useState({
        ID: ''
    })

    const [confirmationMessage, setConfirmationMessage] = React.useState('')
    const [confirmationStatus, setConfirmationStatus] = React.useState(styles.confirmationModalContainerOff)

    function putUser(categoria: any) {
        setConfirmationMessage(`Você tem certeza que deseja editar a categoria"${categoria.CM_NOME}"?`)
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setConfirmationStatus(styles.confirmationModalContainerPencilOn)
        getUser()
        setCatgData({
            ID: categoria.ID,
            CM_NOME: categoria.CM_NOME,
            CM_PARENTE_ID: categoria.CM_PARENTE_ID
        })
    }

    function confirmPutCatg() {
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setMotionsForm('catgButton')
    }

    function cancelPutCatg() {
        setConfirmationStatus(styles.confirmationModalContainerPencilOff)
        setCatgData({
            ID: '',
            CM_NOME: '',
            CM_PARENTE_ID: -1
        })
    }

    function removeCatg(categoria: any) {
        setConfirmationMessage(`Você tem certeza que deseja excluir a categoria "${categoria.CM_NOME}"?`)
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        setConfirmationStatus(styles.confirmationModalContainerTrashOn)

        setCatgDeleteData({
            ID: categoria.ID
        })
    }

    function confirmRemoveCatg() {
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        api.delete(`/categorias/${catgDeleteData.ID}`)
            .then(() => {
                getUser()
            })
    }

    function cancelRemoveCatg() {
        setConfirmationStatus(styles.confirmationModalContainerTrashOff)
        setCatgDeleteData({
            ID: ''
        })
    }

    const userButtonAnimation = useAnimation()
    const formsContainerAnimation = useAnimation()

    function setMotionsForm(element: string) {
        if (element === 'catgButton') {
            userButtonAnimation.start({
                opacity: 0,
                y: -10
            })

            formsContainerAnimation.start({
                height: '320px',
                marginTop: '-100px'
            })
        }
    }

    function resetMotionsForm(element: string) {
        if (element === 'catgButton') {
            userButtonAnimation.start({
                opacity: 1,
                y: 0
            })

            formsContainerAnimation.start({
                height: '0px',
                marginTop: '20px'
            })
        }
    }

    return (
        <div className={styles.allContainer}>
            <ConfirmationModal
                title={confirmationMessage}
                status={confirmationStatus}
                confirm={catgData.ID.length === 0 ? confirmRemoveCatg : confirmPutCatg}
                cancel={catgData.ID.length === 0 ? cancelRemoveCatg : cancelPutCatg}
                iconConfirmation={catgData.ID.length === 0 ? 'faTrashAlt' : 'faPencilAlt'} />
            <div className={styles.titleContainer}>
                <H2Generator textos={["Controle de Categorias", "Aqui você pode criar, editar e remover categorias."]} />
            </div>
            <div className={styles.flexContainer}>
                <div className={styles.catgButtonContainer}>
                    <motion.button
                        className={styles.buttonCategory}
                        onClick={() => setMotionsForm('catgButton')}
                        animate={userButtonAnimation}
                        transition={{ ease: 'easeOut' }}
                        whileTap={{ scale: 0.95 }}>Criar Categoria</motion.button>
                </div>
            </div>
            <motion.div
                className={styles.formsContainer}
                animate={formsContainerAnimation}
                transition={{ duration: 0.3 }}>
                <Forms
                    catgData={catgData}
                    data={data}
                    onSubmitData={getUser}
                    changeContainerUser={resetMotionsForm} />
            </motion.div>
            <div className={styles.tableContainer}>
                <hr className={styles.hr} />
                <CatgTable
                    putUser={putUser}
                    data={data}
                    removeCatg={removeCatg} />
            </div>
        </div>
    )
}